import React, { useEffect } from "react";

import { useTransition, animated } from "@react-spring/web";

interface PanelSliderProps {
  show: boolean;
  className?: string;
  config?: any;
  children: React.ReactNode;
}

const Panel: React.FC<PanelSliderProps> = ({ show, className, config, children }) => {
  const defaultConfig = {
    from: { opacity: 0, right: "-50%" },
    enter: { opacity: 1, right: "0%" },
    leave: { opacity: 0, right: "-50%" },
  }
  const [transitions, api] = useTransition(show, () => ({
   ...defaultConfig,
   ...config
  }));

  useEffect(() => {
    api.start();
  }, [show]);

  return transitions(
    (style, item) =>
      item && (
        <animated.div style={style} className={className}>
          {children}
        </animated.div>
      ),
  );
};

export default Panel;
